import React from "react";

const BAND_IMPACT = [
  "Your songs and setlists stay exactly where they are.",
  "Members keep their access. You won't be able to invite new members on Solo or Free.",
  "On Free, you're capped at adding new songs past 20 and saving more than 1 setlist.",
];

const SOLO_IMPACT = [
  "Your songs and setlists stay exactly where they are.",
  "On Free, you're capped at adding new songs past 20 and saving more than 1 setlist.",
];

export default function DowngradeConfirmModal({
  open,
  currentTier,
  songCount,
  setlistCount,
  memberCount,
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  const impactLines = currentTier === "band" ? BAND_IMPACT : SOLO_IMPACT;

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/75 px-6"
      onClick={(e) => e.target === e.currentTarget && onCancel()}
    >
      <div className="relative w-full max-w-[440px] bg-surface border border-white/[0.11] border-t-2 border-t-brand-gold rounded-sm px-11 py-12 shadow-[0_24px_80px_rgba(0,0,0,0.8)]">
        <div className="mb-3 font-sans text-[0.7rem] tracking-[0.2em] uppercase text-brand-gold">
          Subscription
        </div>
        <h2 className="font-display text-[1.75rem] font-normal leading-[1.2] tracking-[-0.02em] text-text-primary mb-3.5">
          Manage your subscription
        </h2>
        <p className="text-text-secondary text-[0.95rem] leading-[1.65] mb-5">
          Your band currently has {songCount} {songCount === 1 ? "song" : "songs"},{" "}
          {setlistCount} {setlistCount === 1 ? "setlist" : "setlists"},{" "}
          {memberCount} {memberCount === 1 ? "member" : "members"}.
        </p>

        <p className="font-sans text-[0.72rem] uppercase tracking-[0.14em] font-medium text-text-muted mb-2">
          What changes on a lower plan:
        </p>
        <ul className="mb-7 space-y-2 list-none p-0">
          {impactLines.map((line) => (
            <li key={line} className="flex items-start gap-2.5 text-[0.85rem] text-text-secondary">
              <span className="mt-0.5 shrink-0 text-text-muted leading-none">—</span>
              <span>{line}</span>
            </li>
          ))}
        </ul>

        <div className="flex flex-col gap-2.5">
          <button
            className="w-full bg-brand-gold text-[#0d0d0c] font-bold border-0 rounded-sm py-3.5 text-[0.78rem] tracking-[0.15em] uppercase hover:bg-brand-gold/85 transition-colors"
            onClick={onConfirm}
          >
            Continue to billing
          </button>
          <button
            className="w-full bg-transparent text-text-primary border border-white/20 rounded-sm py-3.5 text-[0.78rem] tracking-[0.15em] uppercase hover:border-white/40 transition-colors"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
